var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticStyle:{"margin":"0px","border-radius":"0px"}},[_c('v-card',{staticClass:"theme--dark",staticStyle:{"border-radius":"0"}},[_c('v-card-text',[_c('div',{staticClass:"display-3 font-weight-thin dashHeader"},[_vm._v(" Records ")])])],1),_c('v-data-table',{staticClass:"elevation-1",staticStyle:{"border-radius":"0"},attrs:{"dark":"","headers":_vm.headers,"items":_vm.workoutsData,"items-per-page":5,"item-key":"dayNum","footer-props":{
      showFirstLastPage: true,
      firstIcon: 'mdi-arrow-collapse-left',
      lastIcon: 'mdi-arrow-collapse-right',
      prevIcon: 'mdi-minus',
      nextIcon: 'mdi-plus'
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }